import { createAction, props } from '@ngrx/store';
import { ICustomer } from '../../models/customer.models';

// Load
export const ensureCustomersLoaded = createAction('[Customers] Ensure Customers Loaded');
export const loadCustomers = createAction('[Customers] Load Customers');
export const loadCustomersSuccess = createAction('[Customers] Load Customers Success', props<{ customers: ICustomer[] }>());
export const loadCustomersFailure = createAction('[Customers] Load Customers Failure', props<{ error: string }>());

// Selection
export const setSelectedCustomer = createAction('[Customers] Set Selected Customer', props<{ customer: ICustomer | null }>());

// Create
export const createCustomer = createAction('[Customers] Create Customer', props<{ customer: Partial<ICustomer> }>());
export const createCustomerSuccess = createAction('[Customers] Create Customer Success', props<{ customer: ICustomer }>());
export const createCustomerFailure = createAction('[Customers] Create Customer Failure', props<{ error: string }>());

// Update
export const updateCustomer = createAction('[Customers] Update Customer', props<{ id: string; changes: Partial<ICustomer> }>());
export const updateCustomerSuccess = createAction('[Customers] Update Customer Success', props<{ customer: ICustomer }>());
export const updateCustomerFailure = createAction('[Customers] Update Customer Failure', props<{ error: string }>());

// Delete
export const deleteCustomer = createAction('[Customers] Delete Customer', props<{ id: string }>());
export const deleteCustomerSuccess = createAction('[Customers] Delete Customer Success', props<{ id: string }>());
export const deleteCustomerFailure = createAction('[Customers] Delete Customer Failure', props<{ error: string }>());
